var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"va-page-layout layout-fixed"},[_vm._t("default"),_c('div',{staticClass:"content-wrap",attrs:{"id":"content-wrap"}},[_vm._t("content")],2),_c('div',{staticClass:"made-by-footer"},[_vm._t("footer")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }